import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { AnalysisActivity, DashboardQueryProps } from "@customTypes/dashboard";
import { Pagination } from "@customTypes/index";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };
  const newData = [] as AnalysisActivity[];

  if (res.data.data.length) {
    for (const i in res.data.data) {
      const {
        _id,
        patient_id,
        c_id,
        status,
        lab_type,
        consultation_date,
        consultation_id,
        ordered_by,
        aid,
        lab_date,
      } = res.data.data[i];
      newData.push({
        id: _id,
        patientId: patient_id,
        cId: c_id,
        status,
        type: lab_type,
        physician: ordered_by,
        supportStaff: aid,
        date: new Date(lab_date),
        consultationDate: new Date(consultation_date),
        consultationId: consultation_id,
      });
    }

    return { newData, pagination };
  }

  return null;
};

export const useGetAnalysisActivity = ({
  dateRange,
  startDate,
  endDate,
  userId,
  pagination,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.analysisActivityWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
      pagination,
    }),
    queryFn: () => {
      return api.get("analytics/labs/activity", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
          ...(userId && {
            physician: userId,
          }),
          page: pagination?.page,
          page_size: pagination?.pageSize,
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Analysis activity]", res);
      handleErrors(res, "query");
    },
  });
};
